var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "7 23 86 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "70.699997,26 70.699997,26 70.699997,26 70.699997,26 70.699997,26 21,26 26.700001,35.8 70.699997,35.8 70.699997,35.8 70.699997,35.8 70.799995,35.8 79.199997,30.900001 70.799995,26 70.699997,26 ",
    id: "svg_1",
    fill: "#4AABE1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.699997,47.200001 61.299999,42.299999 30.4,42.299999 36.099998,52.1 61.299999,52.1 ",
    id: "svg_2",
    fill: "#2A78BD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.899998,58.599998 39.799999,58.599998 45.799999,69 51.899998,69 60.900002,63.799999 ",
    fill: "#154D82",
    id: "svg_3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.ce6f624977fe61f4a6ed6b870389f3a2.svg";
export { ForwardRef as ReactComponent };